import { SubmissionWithParticipantsAndValidDecennialCertificate } from "@dune/types";
import {
	Button,
	TableCell,
	TableHead,
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from "@dune/ui";
import { FC } from "react";

export interface BaseSubmissionParticipantTableProps<
	TElement = SubmissionWithParticipantsAndValidDecennialCertificate["participantToConstructionSiteSubmissions"][number],
> {
	submissionParticipants: TElement[];
	constructionSiteId: number;
	selectedParticipantId: number | null;
	onParticipantSelect: (participantId: number, isSelected: boolean) => void;
	disabledInputs?: boolean;
	disabledDocuments?: boolean;
	displayInsurer?: boolean;
}

interface ParticipantsTableHeadProps extends React.ComponentProps<"th"> {
	children: React.ReactNode;
}

export const ParticipantsTableHead = ({
	children,
	className,
	...props
}: ParticipantsTableHeadProps) => {
	return (
		<TableHead className={`truncate ${className || ""}`} {...props}>
			{children}
		</TableHead>
	);
};

interface ParticipantsTableCellProps extends React.ComponentProps<"td"> {
	children: React.ReactNode;
	tooltipContent?: React.ReactNode;
	innerClassName?: string;
}

export const ParticipantsTableCell = ({
	children,
	tooltipContent,
	innerClassName,
	...props
}: ParticipantsTableCellProps) => {
	const content = (
		<div className={innerClassName ?? "truncate"}>{children}</div>
	);

	return (
		<TableCell {...props}>
			{tooltipContent ? (
				<Tooltip>
					<TooltipTrigger asChild>{content}</TooltipTrigger>
					<TooltipContent align="start">{tooltipContent}</TooltipContent>
				</Tooltip>
			) : (
				content
			)}
		</TableCell>
	);
};

export const ParticipantInsurerTableCell: FC<{
	participantInsurer: {
		id: number;
		denomination: string;
	} | null;
	participantId: number;
	constructionSiteId: number;
	setModalState: React.Dispatch<
		React.SetStateAction<{
			isOpen: boolean;
			participantId: number | null;
			constructionSiteId: number | null;
			currentInsurer: {
				id: number;
				denomination: string;
			} | null;
		}>
	>;
}> = ({
	participantInsurer,
	participantId,
	constructionSiteId,
	setModalState,
}) => {
	return (
		<ParticipantsTableCell>
			<div className="flex items-center gap-2">
				<span
					className="truncate"
					title={participantInsurer?.denomination || undefined}
				>
					{participantInsurer?.denomination || "-"}
				</span>
				<Button
					variant="outline"
					size="sm"
					onClick={() =>
						setModalState({
							isOpen: true,
							participantId,
							constructionSiteId,
							currentInsurer: participantInsurer
								? {
										id: participantInsurer.id,
										denomination: participantInsurer.denomination,
									}
								: null,
						})
					}
				>
					{participantInsurer?.denomination ? "Modifier" : "Ajouter"}
				</Button>
			</div>
		</ParticipantsTableCell>
	);
};
